module.exports = __webpack_public_path__ + "img/LT305340173.241b4949.svg";